<template>
  <div id="app">
     <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate () {
    const { body } = document
    const rect = body.getBoundingClientRect()
    const isMobile = rect.width - 1 < 992
    let url = window.location.hash
    if (isMobile && url.indexOf('m_') === -1 && url.indexOf('mn_') === -1 && url.indexOf('mobile') === -1) {
      this.$router.push({name: 'mobileHome'})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue